
export default {
  props: {
    points: {
      type: Number | String,
      default: 0,
    },
  },
};
